/*
 * @LastEditors: caobopan
 * @LastEditTime: 2022-12-21 12:00:41
 * @Description: feature页面
 * @FilePath: /starmaker-starvr-officialnew/src/pages/home/components/homevd/index.js
 */
import React, { useState } from 'react'
import './index.scss';
import xiala from '../../img/web_img_xiala.png'
import people from '../../img/people.png'
import bgviode from '../../img/web_bg_video.png'
import webplay from '../../img/web_button_play.png'
import video from '../../mp4/banner1.mp4';
import closeimg from '../../img/close.png'
import Steam from '../steam'
const Video = ({ next }) => {
  // useEffect(() => {
  //   document.body.addEventListener('mousedown', function () {
  //     const vdo = document.getElementById('player')
  //     vdo.muted = false;
  //   }, false);
  // }, [])
  const [videoshow, setVideoshow] = useState(false);

  const showVideo = () => {
    setVideoshow(true)
  }
  const closeVideo = () => {
    setVideoshow(false)
    const dom = document.getElementById('player')
    dom.pause()
  }
  const nextslide=()=>{
    next()
  }
  return (
    <div className='homevd px-44 pt-20'>
      <div className='imagebox'>
        <img className='bk' src={people} alt="" />
        <img className='bk2 pt-12' src={bgviode} alt=""/>
        <img className='bk3 cursor-pointer' src={webplay} onClick={showVideo} alt=""/>

      </div>
      <div onClick={next} className='absolute video-next-slide bottom-1 left-1/2'>
        <img className='xialaimg' src={xiala} alt="" onClick={nextslide}/>
      </div>
      <div className={`redio-modal ${videoshow && 'show'}`}>
        <img onClick={closeVideo} className='closeImg' src={closeimg} alt="" />
        <video id="player" autoPlay={true} muted loop={true} controls className='w-full' controlsList="nodownload noremoteplayback" disablePictureInPicture={true}>
          <source src={video} />
        </video>
      </div>
      <Steam/>
    </div>
  );
}

export default Video;
